// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__ekMzg","blockMsg":"Message_blockMsg__gG2b3","avatar":"Message_avatar__tk5Aq","avatarBg":"Message_avatarBg__PeV5B","nameAuthor":"Message_nameAuthor__wGr-Z"};